import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoHistorico } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ContratoHistoricoService extends BaseResourceService<ContratoHistorico> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-historicos`, injector);
  }
}
